import React, { useState, MouseEvent, ReactChild } from 'react';
import classNames from 'classnames';

import './ToolTip.scss';
import Icon from '../Icon/Icon';
import useIsMobile from 'src/hooks/useIsMobile';

interface ToolTipProps {
  title?: () => void,
  number?: number,
  message?: () => void | ReactChild,
  className?: string,
  isOpen?: boolean
  handleClick?: () => void,
  formattedMessage?: ReactChild,
  mobileBehavior?: boolean,
  type?: string
}

function ToolTip({
  title,
  message,
  number,
  className,
  isOpen = false,
  handleClick = () => {},
  formattedMessage= '',
  mobileBehavior= false,
  type=''
} : ToolTipProps) {
  const [showModal, setShowModal] = useState(isOpen);

  const mobile = useIsMobile();

  const handleChange = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    if (isOpen){
      handleClick();
    }

    setShowModal(!showModal);
  };

  if (mobile || isOpen || mobileBehavior){

    return (
      <>
        {
          !isOpen && (
            <>
              {
                number && false && <div className={ `tooltip ${ className }` }>
                  <span className="tooltip__text">{ number }</span>
                  <div className={ `tooltip__underline ${ className }__underline` } />
                </div>
              }
              <span className={ `tooltip__title ${ className }--title` }>
                { title }
              </span>
              {
                !showModal && (message || formattedMessage) &&  (<Icon
                  icon="Tooltip"
                  className=
                    { `tooltip__icon  ${ className }--icon` }
                  onClick={ handleChange }
                />)
              }
            </>
          )
        }

        {
          showModal && (
            <>
              <div className={ `tooltip__expanded ${ className }__tooltip--expanded` } onClick={ handleChange }>
              </div>
              <div className={ `tooltip__information ${ className }--information` }>
                <div className="tooltip__close">
                  <Icon icon="close" className="tooltip__close" onClick={ handleChange } />
                </div>
                <div className={ `tooltip__expanded-title ${ className }--expanded-title` }>
                  { title }
                </div>
                { message &&  message }
                { formattedMessage &&  formattedMessage }
              </div>
            </>
          )
        }
      </>
    );
  } else {
    return (
      <>
        <div className={
          classNames({
            tooltip: true,
            'tooltip--big': type === 'big',
            [`tooltip__${ className }`]: className
          })
        }
        >
          {
            number && <>
              <span className={
                classNames({
                  'tooltip__text': true,
                  [`${ className }__text`]: className
                })
              }
              >{ number }</span>
              <div className={
                classNames({
                  'tooltip__underline': true,
                  [`${ className }__underline`]: className
                })
              }
              ></div>
            </>
          }
        </div>
        <span className={
          classNames({
            'tooltip__title': true,
            [`${ className }__title`]: className })
        }
        >
          { title }
        </span>
        {
          (message || formattedMessage) && (<div className="tooltip__box">
            <div className="tooltip__background">
              <div className={
                classNames({
                  'tooltip__symbol': true,
                  'tooltip__symbol--big': type === 'big'
                })
              }
              >
                <Icon
                  icon="Tooltip"
                  className={
                    classNames({
                      'tooltip__icon': true,
                      [`${ className }__icon`]: className
                    })
                  }
                />
              </div>
            </div>
            <div className={
              classNames({
                'tooltip__message': true,
                'tooltip__message--big': type === 'big'
              })
            }
            >
              { message &&  message }
              { formattedMessage && formattedMessage }
            </div>
          </div>)
        }
      </>
    );
  }
}

export default ToolTip;
